import { render, staticRenderFns } from "./serial-movement-history.vue?vue&type=template&id=41261336&"
import script from "./serial-movement-history.vue?vue&type=script&lang=js&"
export * from "./serial-movement-history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports